(function () {
  'use strict';

  var MESSAGE_INTERVAL_MS = 4000;
  var SWIPE_THRESHOLD = 40;
  var WISHLIST_KEY = 'joselito-wishlist';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function bindGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-dot]'));
    var thumbsHost = root.querySelector('[data-hero-product-thumbs]');
    var dotsHost = root.querySelector('[data-hero-product-dots]');
    var stage = root.querySelector('[data-hero-product-stage]');
    if (!slides.length) return;

    var index = 0;
    var activeEl = root.querySelector('[data-hero-product-slide].is-active');
    if (activeEl) {
      var activeIdx = slides.indexOf(activeEl);
      if (activeIdx >= 0) index = activeIdx;
    }

    function isMain(i) {
      return slides[i].getAttribute('data-media-main') !== 'false';
    }

    function mainIndices() {
      var list = [];
      slides.forEach(function (slide, i) {
        if (isMain(i)) list.push(i);
      });
      return list;
    }

    /* Visible set: the shared (main) pictures, or only the selected variant's own picture. */
    var order = isMain(index) ? mainIndices() : [index];

    function showSet(indices) {
      order = indices;
      thumbs.forEach(function (thumb, i) {
        thumb.hidden = indices.indexOf(i) === -1;
      });
      dots.forEach(function (dot, i) {
        dot.hidden = indices.indexOf(i) === -1;
      });
      if (thumbsHost) thumbsHost.hidden = indices.length < 2;
      if (dotsHost) dotsHost.hidden = indices.length < 2;
    }

    function pauseVideos() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === index) {
          if (!prefersReducedMotion()) video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function goTo(next, options) {
      var max = slides.length;
      if (max < 1) return;
      var keepCover = options && options.keepCover;
      if (!keepCover && typeof root._heroProductClearVariantCover === 'function') {
        root._heroProductClearVariantCover();
      }
      index = ((next % max) + max) % max;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      pauseVideos();
    }

    function goToMediaId(mediaId, options) {
      if (mediaId == null || mediaId === '') return false;
      var id = String(mediaId);
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].getAttribute('data-media-id') === id) {
          showSet(isMain(i) ? mainIndices() : [i]);
          goTo(i, options);
          return true;
        }
      }
      return false;
    }

    function step(direction) {
      if (order.length < 2) return;
      var pos = order.indexOf(index);
      if (pos === -1) pos = 0;
      goTo(order[(pos + direction + order.length) % order.length]);
    }

    root._heroProductGoTo = goTo;
    root._heroProductGoToMedia = goToMediaId;

    if (slides.length < 2) {
      goTo(index, { keepCover: true });
      return;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (stage) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      stage.addEventListener(
        'touchstart',
        function (event) {
          if (!event.changedTouches || !event.changedTouches[0]) return;
          startX = event.changedTouches[0].clientX;
          startY = event.changedTouches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        function (event) {
          if (!tracking || !event.touches || !event.touches[0]) return;
          var dx = Math.abs(event.touches[0].clientX - startX);
          var dy = Math.abs(event.touches[0].clientY - startY);
          if (dx > 8 && dx > dy) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      stage.addEventListener(
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          var deltaX = event.changedTouches[0].clientX - startX;
          var deltaY = event.changedTouches[0].clientY - startY;
          if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          step(deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchcancel',
        function () {
          tracking = false;
        },
        { passive: true }
      );
    }

    goTo(index);
  }

  function bindDescription(root) {
    var body = root.querySelector('[data-hero-product-description]');
    var button = root.querySelector('[data-hero-product-more]');
    if (!body || !button) return;

    var expandLabel = button.getAttribute('data-label-more') || '';
    var collapseLabel = button.getAttribute('data-label-less') || '';
    var MAX_LINES = 3;

    function countLines() {
      var width = Math.ceil(body.getBoundingClientRect().width);
      if (width < 8) return 0;

      var parent = body.parentNode;
      if (!parent) return 0;

      var clone = body.cloneNode(true);
      clone.removeAttribute('data-hero-product-description');
      clone.classList.remove('is-expanded');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = [
        'position:absolute',
        'left:0',
        'top:0',
        'visibility:hidden',
        'pointer-events:none',
        'display:block',
        'height:auto',
        'max-height:none',
        'overflow:visible',
        '-webkit-box-orient:initial',
        '-webkit-line-clamp:unset',
        'line-clamp:unset',
        'width:' + width + 'px'
      ].join(';');
      parent.appendChild(clone);

      var range = document.createRange();
      range.selectNodeContents(clone);
      var rects = range.getClientRects();
      var lines = rects.length;
      parent.removeChild(clone);
      return lines;
    }

    function needsToggle() {
      if (body.classList.contains('is-expanded')) return true;
      return countLines() > MAX_LINES;
    }

    function sync() {
      var show = needsToggle();
      button.classList.toggle('is-visible', show);
      button.hidden = !show;
      if (!show && body.classList.contains('is-expanded')) {
        body.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = expandLabel;
      }
    }

    button.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? collapseLabel : expandLabel;
      if (!expanded) {
        window.requestAnimationFrame(sync);
      }
    });

    sync();
    window.requestAnimationFrame(function () {
      sync();
      window.requestAnimationFrame(sync);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(function () {});
    }
    window.addEventListener('resize', sync);
  }

  function bindMessages(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-promise]'));
    if (items.length < 2) return;

    var index = 0;
    var timer = null;

    function show(next) {
      index = next % items.length;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    function start() {
      stop();
      if (prefersReducedMotion()) return;
      if (window.matchMedia('(min-width: 1024px)').matches === false) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, MESSAGE_INTERVAL_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    show(0);
    start();
    window.addEventListener('resize', start);
    reducedMotion.addEventListener('change', start);
  }

  function bindWishlist(root) {
    var button = root.querySelector('[data-hero-product-wishlist]');
    if (!button) return;

    var productId = root.getAttribute('data-product-id') || '';
    var persist = root.getAttribute('data-wishlist-persist') === 'true';
    var addLabel = button.getAttribute('data-label-add') || '';
    var addedLabel = button.getAttribute('data-label-added') || '';

    function setState(on) {
      root.classList.toggle('is-wishlisted', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.textContent = on ? addedLabel : addLabel;
    }

    if (persist && productId) {
      setState(readWishlist().indexOf(productId) !== -1);
    } else {
      setState(root.classList.contains('is-wishlisted'));
    }

    button.addEventListener('click', function () {
      var next = !root.classList.contains('is-wishlisted');
      setState(next);
      if (!persist || !productId) return;
      var ids = readWishlist().filter(function (id) {
        return id !== productId;
      });
      if (next) ids.push(productId);
      writeWishlist(ids);
    });
  }

  function bindDock(root) {
    var dock = root.querySelector('[data-hero-product-dock]');
    var cta = root.querySelector('[data-hero-product-cta]');
    if (!dock || !cta) return;

    var desktopMq = window.matchMedia('(min-width: 1024px)');
    var footer = document.querySelector('[data-footer]');
    var DOCK_GAP = 24;

    function sync() {
      var rect = cta.getBoundingClientRect();
      var visible;
      if (desktopMq.matches) {
        /* Desktop: only after scrolling past the main CTA. */
        visible = rect.bottom < 0;
      } else {
        /* Mobile: CTA starts below the fold — show dock until it enters view. */
        visible = rect.bottom <= 0 || rect.top >= window.innerHeight;
      }

      /* Lift the dock so it stays above the footer instead of overlapping it. */
      var bottom = DOCK_GAP;
      if (footer) {
        var overlap = window.innerHeight - footer.getBoundingClientRect().top;
        if (overlap > 0) bottom = DOCK_GAP + overlap;
      }
      dock.style.bottom = bottom + 'px';

      dock.classList.toggle('is-visible', visible);
    }

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', sync);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(sync);
    }
  }

  function syncVariantPrices(root, price) {
    if (!price) return;
    var dockPrice = root.querySelector('[data-hero-product-dock-price]');
    var heroPrice = root.querySelector('[data-hero-product-price]');
    if (dockPrice) dockPrice.textContent = price;
    if (heroPrice) heroPrice.textContent = price;
  }

  function syncProductFormat(variantId) {
    if (variantId == null || variantId === '') return;
    var mount = document.querySelector('[data-product-format-mount]');
    if (!mount) return;
    var source = document.querySelector(
      '[data-product-format-source][data-variant-id="' + String(variantId) + '"]'
    );
    if (!source) return;
    mount.innerHTML = source.innerHTML;
  }

  function setVariantId(root, variantId) {
    if (variantId == null || variantId === '') return;
    root.querySelectorAll('[data-hero-product-variant-id], input[name="id"]').forEach(function (input) {
      if (input.closest('[data-hero-product-variants]')) return;
      input.value = variantId;
    });
    syncProductFormat(variantId);
  }

  var VARIANT_EASE = 'cubic-bezier(.77, 0, .18, 1)';
  var VARIANT_EASE_OUT = 'cubic-bezier(.16, 1, .3, 1)';

  function bindVariantImageSwap(root) {
    var stage = root.querySelector('[data-hero-product-stage]');
    var layersHost = root.querySelector('[data-hero-product-variant-layers]');
    var curtain = root.querySelector('[data-hero-product-variant-curtain]');
    if (!stage || !layersHost) return;

    var running = [];
    var currentMediaId = '';

    function track(anim) {
      running.push(anim);
      return anim;
    }

    function finishAll() {
      running.forEach(function (anim) {
        try {
          anim.finish();
        } catch (error) {
          /* ignore */
        }
      });
      running = [];
    }

    function readDuration() {
      var raw = parseInt(root.getAttribute('data-variant-transition-duration') || '1200', 10);
      return isNaN(raw) ? 1200 : raw;
    }

    function readMode() {
      return root.getAttribute('data-variant-image-transition') || 'reveal_parallax';
    }

    function makeLayer(url) {
      var layer = document.createElement('div');
      layer.className = 'hero-product__variant-layer';
      layer.innerHTML =
        '<div class="hero-product__variant-layer-move"><img src="' +
        String(url).replace(/"/g, '&quot;') +
        '" alt=""></div>';
      layersHost.appendChild(layer);
      return layer;
    }

    function clearLayers(keep) {
      Array.prototype.slice.call(layersHost.children).forEach(function (node) {
        if (node !== keep) node.remove();
      });
    }

    function activeSlide() {
      return root.querySelector('[data-hero-product-slide].is-active');
    }

    function slideFor(mediaId) {
      return root.querySelector('[data-hero-product-slide][data-media-id="' + mediaId + '"]');
    }

    function slideUrl(slide) {
      var img = slide && slide.querySelector('img');
      return img ? img.currentSrc || img.src || '' : '';
    }

    function ensureBaseLayer() {
      if (layersHost.lastElementChild) return layersHost.lastElementChild;
      var seedUrl = slideUrl(activeSlide());
      if (!seedUrl) return null;
      var layer = makeLayer(seedUrl);
      layer.style.clipPath = 'none';
      return layer;
    }

    /** Hand the stage back to the real slide (and its visible set), then drop the overlay layer. */
    function settle(layer, mediaId) {
      clearLayers(layer);
      if (typeof root._heroProductGoToMedia === 'function') {
        root._heroProductGoToMedia(mediaId, { keepCover: true });
      }
      var slide = slideFor(mediaId);
      var img = slide && slide.querySelector('img');
      function drop() {
        window.setTimeout(function () {
          if (layer.parentNode) layer.remove();
        }, 320);
      }
      if (img && !img.complete) {
        img.addEventListener('load', drop, { once: true });
        img.addEventListener('error', drop, { once: true });
      } else {
        drop();
      }
    }

    function clearVariantCover() {
      if (!layersHost.children.length) return;
      finishAll();
      clearLayers(null);
      var active = activeSlide();
      currentMediaId = active ? active.getAttribute('data-media-id') || '' : '';
    }

    function swapImage(url, mediaId) {
      var nextId = mediaId != null && mediaId !== '' ? String(mediaId) : '';
      var target = nextId ? slideFor(nextId) : null;
      var shown = layersHost.children.length ? slideFor(currentMediaId) : activeSlide();
      var shownId = shown ? shown.getAttribute('data-media-id') || '' : '';
      if (!target) {
        /* Variant without its own picture: return to the shared gallery if a variant-only one is showing. */
        if (!shown || shown.getAttribute('data-media-main') !== 'false') return;
        target = root.querySelector('[data-hero-product-slide]:not([data-media-main="false"])');
        if (!target) return;
        nextId = target.getAttribute('data-media-id') || '';
        url = '';
      }
      if (nextId === shownId) return;
      url = url || slideUrl(target);
      if (!url) {
        currentMediaId = nextId;
        if (typeof root._heroProductGoToMedia === 'function') root._heroProductGoToMedia(nextId);
        return;
      }

      finishAll();
      var duration = readDuration();
      var mode = readMode();
      var old = ensureBaseLayer();
      var layer = makeLayer(url);
      var move = layer.querySelector('.hero-product__variant-layer-move');
      var oldMove = old && old.querySelector('.hero-product__variant-layer-move');
      currentMediaId = nextId;

      function after() {
        settle(layer, nextId);
      }

      if (prefersReducedMotion()) {
        track(layer.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 250, fill: 'forwards' })).finished.then(
          after
        );
        return;
      }

      if (mode === 'curtain' && curtain) {
        layer.style.clipPath = 'inset(100% 0 0 0)';
        var half = duration * 0.5;
        track(
          curtain.animate([{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], {
            duration: half,
            easing: 'cubic-bezier(.7,0,.3,1)',
            fill: 'forwards'
          })
        ).finished.then(function () {
          layer.style.clipPath = 'none';
          if (old && old !== layer) old.remove();
          track(
            move.animate([{ transform: 'scale(1.08)' }, { transform: 'scale(1)' }], {
              duration: duration * 0.9,
              easing: VARIANT_EASE_OUT
            })
          );
          track(
            curtain.animate([{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], {
              duration: half,
              easing: 'cubic-bezier(.7,0,.3,1)',
              fill: 'forwards'
            })
          ).finished.then(after);
        });
        return;
      }

      var parallax = mode === 'reveal_parallax';
      layer.style.clipPath = 'inset(100% 0 0 0)';
      var reveal = track(
        layer.animate([{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0% 0 0 0)' }], {
          duration: duration,
          easing: VARIANT_EASE,
          fill: 'both'
        })
      );
      track(
        move.animate(
          parallax
            ? [{ transform: 'translateY(18%) scale(1.15)' }, { transform: 'translateY(0) scale(1)' }]
            : [{ transform: 'scale(1.1)' }, { transform: 'scale(1)' }],
          {
            duration: duration * 1.15,
            easing: parallax ? VARIANT_EASE : VARIANT_EASE_OUT,
            fill: 'both'
          }
        )
      );
      if (oldMove) {
        track(
          oldMove.animate(
            parallax
              ? [
                  { transform: 'translateY(0)', filter: 'brightness(1)' },
                  { transform: 'translateY(-12%)', filter: 'brightness(.45)' }
                ]
              : [{ filter: 'brightness(1)' }, { filter: 'brightness(.6)' }],
            { duration: duration, easing: VARIANT_EASE, fill: 'both' }
          )
        );
      }
      reveal.finished.then(function () {
        layer.style.clipPath = 'none';
        after();
      });
    }

    root._heroProductSwapVariantImage = swapImage;
    root._heroProductClearVariantCover = clearVariantCover;

    var initial = activeSlide();
    currentMediaId = initial ? initial.getAttribute('data-media-id') || '' : '';
  }

  function bindVariantTextSwap(root) {
    var running = [];

    function track(anim) {
      running.push(anim);
      return anim;
    }

    function finishAll() {
      running.forEach(function (anim) {
        try {
          anim.finish();
        } catch (error) {
          /* ignore */
        }
      });
      running = [];
    }

    function readInt(name, fallback) {
      var raw = parseInt(root.getAttribute(name) || '', 10);
      return isNaN(raw) ? fallback : raw;
    }

    /** Inline values (selector, spec values): old/new stacked in a clipped grid cell, then back to plain text. */
    function swapInline(el, text, delay, mode) {
      var token = {};
      el._heroProductSwap = token;
      var prev = document.createElement('span');
      prev.textContent = el.textContent;
      prev.setAttribute('aria-hidden', 'true');
      var next = document.createElement('span');
      var wrap = document.createElement('span');
      wrap.className = 'hero-product__swap';
      wrap.appendChild(prev);
      wrap.appendChild(next);
      el.textContent = '';
      el.appendChild(wrap);

      function done() {
        if (el._heroProductSwap === token) el.textContent = text;
      }

      if (mode === 'chars') {
        Array.prototype.forEach.call(text, function (char) {
          var c = document.createElement('span');
          c.className = 'hero-product__swap-char';
          c.textContent = char;
          next.appendChild(c);
        });
        track(
          prev.animate([{ opacity: 1 }, { opacity: 0, transform: 'translateY(-30%)' }], {
            duration: 300,
            delay: delay,
            easing: 'ease-in',
            fill: 'both'
          })
        );
        var chars = Array.prototype.slice.call(next.children);
        if (!chars.length) {
          done();
          return;
        }
        var last;
        chars.forEach(function (c, i) {
          last = track(
            c.animate([{ transform: 'translateY(110%)' }, { transform: 'translateY(0)' }], {
              duration: 650,
              delay: delay + 180 + i * 28,
              easing: VARIANT_EASE_OUT,
              fill: 'both'
            })
          );
        });
        last.finished.then(done, done);
        return;
      }

      next.textContent = text;
      if (mode === 'blur') {
        track(
          prev.animate(
            [
              { opacity: 1, filter: 'blur(0)' },
              { opacity: 0, filter: 'blur(4px)', transform: 'translateY(-8px)' }
            ],
            { duration: 380, delay: delay, easing: 'ease-in', fill: 'both' }
          )
        );
        track(
          next.animate(
            [
              { opacity: 0, filter: 'blur(6px)', transform: 'translateY(8px)' },
              { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' }
            ],
            { duration: 700, delay: delay + 260, easing: VARIANT_EASE_OUT, fill: 'both' }
          )
        ).finished.then(done, done);
        return;
      }

      track(
        prev.animate(
          [
            { transform: 'translateY(0)', opacity: 1 },
            { transform: 'translateY(-105%)', opacity: 0 }
          ],
          { duration: 420, delay: delay, easing: 'cubic-bezier(.55,0,.7,.2)', fill: 'both' }
        )
      );
      track(
        next.animate([{ transform: 'translateY(105%)' }, { transform: 'translateY(0)' }], {
          duration: 720,
          delay: delay + 220,
          easing: VARIANT_EASE_OUT,
          fill: 'both'
        })
      ).finished.then(done, done);
    }

    /** Paragraphs always use the soft blur (Anada "blurBlock"); a ghost copy fades out so the line clamp stays intact. */
    function swapBlock(el, delay) {
      var host = el.parentNode;
      if (!host) return;
      var ghost = el.cloneNode(true);
      ghost.removeAttribute('data-hero-product-description');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.classList.add('hero-product__swap-ghost');
      ghost.style.top = el.offsetTop + 'px';
      ghost.style.left = el.offsetLeft + 'px';
      ghost.style.width = el.offsetWidth + 'px';
      host.appendChild(ghost);
      track(
        ghost.animate(
          [
            { opacity: 1, filter: 'blur(0)' },
            { opacity: 0, filter: 'blur(4px)', transform: 'translateY(-6px)' }
          ],
          { duration: 380, delay: delay, easing: 'ease-in', fill: 'both' }
        )
      ).finished.then(
        function () {
          ghost.remove();
        },
        function () {
          ghost.remove();
        }
      );
      track(
        el.animate(
          [
            { opacity: 0, filter: 'blur(6px)', transform: 'translateY(6px)' },
            { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' }
          ],
          { duration: 700, delay: delay + 260, easing: VARIANT_EASE_OUT, fill: 'backwards' }
        )
      );
    }

    root._heroProductSwapVariantText = function (selectorEl, label, price, pricePerKilo) {
      finishAll();
      var priceEl = price ? root.querySelector('[data-hero-product-price]') : null;

      function specText(value) {
        if (pricePerKilo && value.hasAttribute('data-hero-product-price-per-kilo')) return pricePerKilo;
        return value.textContent;
      }

      if (prefersReducedMotion()) {
        if (selectorEl) selectorEl.textContent = label;
        if (priceEl) priceEl.textContent = price;
        root.querySelectorAll('[data-hero-product-price-per-kilo]').forEach(function (value) {
          value.textContent = specText(value);
        });
        return;
      }
      var mode = root.getAttribute('data-variant-text-transition') || 'slide';
      var base = readInt('data-variant-text-delay', 180);
      var stagger = readInt('data-variant-text-stagger', 60);

      if (priceEl) swapInline(priceEl, price, 0, mode);
      if (selectorEl) swapInline(selectorEl, label, 0, mode);

      var description = root.querySelector('[data-hero-product-description]');
      if (description) swapBlock(description, base);

      root.querySelectorAll('.hero-product__specs').forEach(function (list) {
        list.querySelectorAll('.hero-product__spec-value').forEach(function (value, n) {
          swapInline(value, specText(value), base + stagger * (n + 1), mode);
        });
      });
    };
  }

  function bindVariantSelector(root) {
    var selector = root.querySelector('[data-hero-product-selector]');
    if (!selector) return;

    var trigger = selector.querySelector('[data-hero-product-selector-trigger]');
    var list = selector.querySelector('[data-hero-product-selector-list]');
    var valueEl = selector.querySelector('[data-hero-product-selector-value]');
    var options = Array.prototype.slice.call(selector.querySelectorAll('[data-hero-product-selector-option]'));
    if (!trigger || !list) return;

    var closeTimer = null;

    function setOpen(open) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (open) {
        selector.classList.remove('is-closing');
        selector.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        list.setAttribute('aria-hidden', 'false');
        return;
      }
      if (!selector.classList.contains('is-open')) {
        selector.classList.remove('is-closing');
        trigger.setAttribute('aria-expanded', 'false');
        list.setAttribute('aria-hidden', 'true');
        return;
      }
      selector.classList.remove('is-open');
      selector.classList.add('is-closing');
      trigger.setAttribute('aria-expanded', 'false');
      list.setAttribute('aria-hidden', 'true');
      closeTimer = window.setTimeout(function () {
        selector.classList.remove('is-closing');
        closeTimer = null;
      }, 420);
    }

    function selectOption(option) {
      if (!option || option.disabled) return;
      if (option.getAttribute('aria-selected') === 'true') {
        setOpen(false);
        return;
      }
      options.forEach(function (opt) {
        opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
      });
      var label = option.getAttribute('data-option-label') || '';
      if (!label) {
        var labelNode = option.querySelector('.hero-product__selector-option-label');
        label = labelNode ? labelNode.textContent.trim() : (option.textContent || '').trim();
      }
      var animateText = typeof root._heroProductSwapVariantText === 'function';
      if (valueEl && !animateText) valueEl.textContent = label;
      var price = option.getAttribute('data-hero-product-variant-price') || '';
      setVariantId(root, option.getAttribute('data-variant-id') || '');
      if (animateText) {
        var dockPrice = root.querySelector('[data-hero-product-dock-price]');
        if (dockPrice && price) dockPrice.textContent = price;
      } else {
        syncVariantPrices(root, price);
      }
      setOpen(false);
      window.setTimeout(function () {
        if (animateText) {
          root._heroProductSwapVariantText(valueEl, label, price, option.getAttribute('data-price-per-kilo') || '');
        }
        if (typeof root._heroProductSwapVariantImage === 'function') {
          root._heroProductSwapVariantImage(
            option.getAttribute('data-image-url') || '',
            option.getAttribute('data-media-id')
          );
        }
      }, 140);
    }

    trigger.addEventListener('click', function () {
      setOpen(!selector.classList.contains('is-open'));
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        selectOption(option);
      });
    });

    document.addEventListener('click', function (event) {
      if (!selector.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function bindVariants(root) {
    bindVariantImageSwap(root);
    if (root.querySelector('[data-hero-product-selector]')) bindVariantTextSwap(root);
    bindVariantSelector(root);

    var dialog = root.querySelector('[data-hero-product-variants]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-open-variants]'));
    var closers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-variants-close]'));
    var radios = Array.prototype.slice.call(dialog.querySelectorAll('[data-hero-product-variant-price]'));

    function open() {
      if (!dialog.open) dialog.showModal();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        open();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        syncVariantPrices(root, radio.getAttribute('data-hero-product-variant-price') || '');
        setVariantId(root, radio.getAttribute('data-variant-id') || radio.value || '');
      });
    });

    var checked = dialog.querySelector('[data-hero-product-variant-price]:checked');
    if (checked) {
      syncVariantPrices(root, checked.getAttribute('data-hero-product-variant-price') || '');
      setVariantId(root, checked.getAttribute('data-variant-id') || checked.value || '');
    }
  }

  function bindContact(root) {
    var overlay = root.querySelector('[data-hero-product-contact]');
    if (!overlay) return;

    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-open-contact]'));
    var closers = Array.prototype.slice.call(overlay.querySelectorAll('[data-hero-product-contact-dismiss]'));
    var closeBtn = overlay.querySelector('[data-hero-product-contact-close]');

    function open() {
      overlay.hidden = false;
      document.body.classList.add('is-hero-product-contact-open');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('is-hero-product-contact-open');
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      close();
    });
  }

  function bind(root) {
    if (!root || root._heroProductBound) return;
    root._heroProductBound = true;
    bindGallery(root);
    bindDescription(root);
    bindMessages(root);
    bindWishlist(root);
    bindDock(root);
    bindVariants(root);
    bindContact(root);
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-hero-product]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
